import axios from 'axios'
import qs from 'qs'

let baseURL
// 开发环境
if (process.env.NODE_ENV === 'development') {
  baseURL = ''
  
  // 编译环境
} else {
  // 测试环境
  if (process.env.type === 'test') {
    baseURL = '//test.test08.com.cn'
    
    // 预服环境
  } else if (process.env.type === 'pre') {
    baseURL = '//calendar.yiban.206'
    
    // 正式环境
  } else {
    baseURL = '//www.test08.com.cn'
    
  }
}
const request = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 10000
})

export default {
  baseURL,
  // 首页BANNER
  getIndexBanner: (params) => request.post('/api/getAdListAjax', qs.stringify(params)),
  // 首页分类
  getIndexType: (params) => request.post('/api/getType', qs.stringify(params)),
  // 首页日历
  getMyCalendar: (params) => request.post('/api/getMyCalendar', qs.stringify(params)),
  // 分类考试列表
  getExamList: (params) => request.post('/api/getExamList', qs.stringify(params)),
  // 日历单日关注列表
  getMyCalendarDay: (params) => request.post('/api/getMyCalendarDay', qs.stringify(params)),
  // 考试详情
  getExamInfo: (params) => request.post('/api/getExamInfo', qs.stringify(params)),
  // 考试详情4*4TAB切换文案
  getInfoType: (params) => request.post('/api/getInfoType', qs.stringify(params)),
  // 考试详情4*4列表
  getExamDetail: (params) => request.post('/api/getExamDetail', qs.stringify(params)),
  // 考试详情4*4详情
  getDetailInfo: (params) => request.post('/api/getDetailInfo', qs.stringify(params)),
  // 我关注的考试列表
  getMyExamList: (params) => request.post('/api/getMyExamList', qs.stringify(params)),
  // 推荐列表
  getRecommendList: (params) => request.post('/api/getRecommendList', qs.stringify(params)),
  // // 首页列表
  // getIndexList: (params) => request.post('/api/getCalendarListAjax', qs.stringify(params)),
  // // 考试详情&介绍&问题
  // getInfoList: (params) => request.post('/api/getInfoListAjax', qs.stringify(params)),
  // // 考试相关资料
  // getDataList: (params) => request.post('/api/getDataListAjax', qs.stringify(params)),
  // // 动态热点
  // getTrendsList: (params) => request.post('/api/getTrendsListAjax', qs.stringify(params)),
  // 提醒添加
  addCalendar: (params) => request.post('/api/addExamCalendar', qs.stringify(params)),
  // 提醒删除
  delCalendar: (params) => request.post('/api/delExamCalendar', qs.stringify(params)),
  // 获取个人资料
  getUserInfo: (params) => request.post('/api/getUserInfoAjax', qs.stringify(params)),
  // 首页考试历推荐列表
  getTopCalendar: (params) => request.post('/api/getTopCalendar', qs.stringify(params)),
  // 考试历列表
  getCalendarList: (params) => request.post('/api/getCalendarList', qs.stringify(params)),
  // 考试历详情
  getCalendarDetail: (params) => request.post('/api/getCalendarDetail', qs.stringify(params)),
  // 考试历考试类型
  getSubType: (params) => request.post('/api/getSubType', qs.stringify(params)),
  // 考试历省份
  getAreaList: (params) => request.post('/api/getAreaList', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/index.js